/* eslint-disable unicorn/prefer-global-this */
'use client';

import {useEffect} from "react";

export default function A11yScript() {
  useEffect(() => {
    if (process.env.NODE_ENV !== 'development') return;

    if (document.querySelector('#accessibe-script')) return;

    const script = document.createElement('script');
    script.id = 'accessibe-script';
    script.src = 'https://acsbapp.com/apps/app/dist/js/app.js';
    script.async = true;

    script.addEventListener('load', () => {
      // accessiBe expects this global init
      // @ts-expect-error - ignored because we don't have types for this library
      if (window.acsbJS) {
        // @ts-expect-error - ignored because we don't have types for this library
        window.acsbJS.init();
      }
    });

    const target = document.querySelector('head') || document.body;
    target.append(script);
  }, []);

  return null;
}
